import { DestroyRef, inject, Injectable } from '@angular/core';
import { GoogleAnalyticsService } from '@lx/shared/google-analytics';
import { GoogleAnalyticsEventEnum } from '../../../google-analytics';
import { QuoteToolLiteStore } from '../../../store';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

/**
 * Service to handle GA tracking.
 * Tracks the deeplink_opened event after the store is fully initialized with all quote data.
 */
@Injectable({
  providedIn: 'root',
})
export class DeeplinkTrackingService {
  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);
  private readonly qtLiteStore = inject(QuoteToolLiteStore);
  private readonly destroyRef = inject(DestroyRef);

  /**
   * Tracks the deeplink opened event in GA if deeplinkType exists in the store.
   * Should be called after the store is fully initialized so all quote data is available.
   *
   * Subscribes to deeplinkType$ and tracks the event using GoogleAnalyticsService
   * which ensures the complete data layer is populated.
   */
  trackDeeplinkOpenedIfPresent(): void {
    this.qtLiteStore.deeplinkType$.pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe((deeplinkType) => {
      if (deeplinkType) {
        this.googleAnalyticsService.trackEvent(GoogleAnalyticsEventEnum.DeeplinkOpened, 'deeplink');
      }
    });
  }
}
